import React, { useState } from 'react'
import { NumberFormatValues } from 'react-number-format/types/types'
import { Icons } from '../../../types/enums'
import { ReactBaseElement } from '../../../types/react'
import { StyledError } from '../../styled/Error'
import Icon from '../Icon'
import {
  StyledInputContainer,
  StyledTextContainer,
  StyledLabel,
  StyledNumeric,
} from './styled'

type NumericInputProps = {
  label?: string
  placeholder?: string
  required?: boolean
  autocomplete?: string
  error?: string
  type?: 'text' | 'password' | 'email' | 'number'
  preIcon?: Icons
  afterIcon?: Icons
  maxLength?: number
  formatter?: 'uppercase' | 'lowercase' | 'currency'
  onChange?: (value: string) => void
} & ReactBaseElement

const NumericInput = React.forwardRef(
  (props: NumericInputProps, ref: React.Ref<HTMLInputElement>) => {
    const [value, setValue] = useState<string>('')

    const handleChange = (values: NumberFormatValues) => {
      if (props.onChange) {
        props.onChange(values.value)
      }
      setValue(values.value)
    }

    return (
      <StyledInputContainer>
        {props.preIcon && <Icon name={props.preIcon} />}
        <StyledLabel>{props.label}</StyledLabel>
        <StyledTextContainer>
          <StyledNumeric
            thousandSeparator=","
            prefix={'$'}
            decimalScale={2}
            placeholder={props.placeholder || '...'}
            required={props.required}
            autoComplete={props.autocomplete}
            maxLength={props.maxLength}
            onValueChange={handleChange}
          />
          <input ref={ref} value={value} readOnly hidden />
          {props.error && <StyledError>{props.error}</StyledError>}
        </StyledTextContainer>
      </StyledInputContainer>
    )
  }
)

export default NumericInput
